import { SubHeaderOffset } from './SubHeader'
import styles from './Main.css'

const Main = (props) => {
  const { children } = props
  return (
    <div className={styles.main}>
      <SubHeaderOffset />
      <div className={styles.mainContent}>
        {children}
      </div>
    </div>
  )
}

export default Main
